/**
 * ? @description : SPOC : Individual Trainer Data Modal
 */

// Dependencies
import React, { Fragment, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tab,

  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";

// Axios Component
import Axios from "../../../../../../axios/Axios";
import { Close } from "@mui/icons-material";
import axios from "axios";
import dayjs from "dayjs";

function TrainerData(props) {
  // * Data Initialization
  const id = props.selecteddata[0];

  // * State Variable
  const [TeacherData, setTeacherData] = useState([]);
  const [tabValue, setTabValue] = useState(1);

  // * Function Call on Every Render
  useEffect(() => {
    /**
   * ? API Function Call
   * ? Request Type : Get Method
   * ? Response : Individual Teacher Data
   */
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          const options = {
            method: "get",
            url: `/teacher/${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };

          let response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );

          if (response.status === 200) {
            setTeacherData(response.data);
          }
        } catch (error) {
          if(!axios.isCancel(error)) {
            console.log(error);
          }
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [id]);

  const tentativeStart = dayjs(TeacherData[0]?.tentative_start_date).format("DD-MM-YYYY");
  const RegisterDate = dayjs(TeacherData[0]?.tcreated_at).format("DD-MM-YYYY");

  return (
    <Fragment>
      {TeacherData.length > 0 && (
        <Dialog
          open={props.open}
          onClose={props.onClose}
          maxWidth="lg"
          fullWidth
          aria-labelledby="dialog-title"
          aria-describedby="dialog-content"
        > 
          <DialogContent>
            <DialogContentText id="dialog-content">
              <Box>
                <TabContext value={tabValue}>
                  {/* Tab Headings */}
                  <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <TabList
                      aria-label="Tabs Header"
                      onChange={(e, newValue) => {
                        e.preventDefault();
                        setTabValue(newValue);
                      }}
                    >
                      <Tab label="Primary" value={1} />
                      <Tab label="Languages" value={2} />
                      <Tab label="Group" value={3} />
                      <Tab label="Adarsh Palm Retreat" value={4} />
                    </TabList>
                    <IconButton onClick={() => props.onClose()}>
                      <Close/>
                    </IconButton>
                  </Box>

                  {/* Tab Panels */}
                  <TabPanel value={1}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Unique Id
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].teacher_id}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Teacher Name
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].teacher_name}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Email
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].email}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Phone Number
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].contactno}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Tentative Start Date
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {tentativeStart}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Registered Date.....
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {RegisterDate}
                      </Typography>
                    </Box>
                  </TabPanel>

                  <TabPanel value={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 1
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_1}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 2
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_2}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 3
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_3}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 4
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_4}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 5
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_5}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Language 6
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].spoke_lang_6}
                      </Typography>
                    </Box>
                  </TabPanel>

                  <TabPanel value={3}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Box sx={{ mr: "100px" }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Batch Id
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].group_id}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Batch Name
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].group_name}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Group Status
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].group_status}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Teacher Mapped Status
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].teacher_mapped_status}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Teacher Mapped To
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].mapped_to_student}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 250 }}
                          >
                            Audio Status
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].audio_status}
                          </Typography>
                        </Box>
                      </Box>

                      <Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 200 }}
                          >
                            Teacher Status
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].teacher_status}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 200 }}
                          >
                            Role
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].role}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ width: 200 }}
                          >
                            Comments
                          </Typography>
                          <Typography
                            variant="p"
                            component="div"
                            sx={{ color: "#1d3faa" }}
                          >
                            {TeacherData[0].note_description}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </TabPanel>

                  <TabPanel value={4}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        Residing in APR
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].is_apr_residing === true ? "Yes" : "No"}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        APR Home Address
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].apr_homeaddress}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        APR Reference Name
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].apr_reference_name}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        APR Reference Contact
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].apr_reference_contact}
                      </Typography>
                    </Box>

                       <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ width: 200 }}
                      >
                        APR Reference Contact
                      </Typography>
                      <Typography
                        variant="p"
                        component="div"
                        sx={{ color: "#1d3faa" }}
                      >
                        {TeacherData[0].apr_reference_contact}
                      </Typography>
                    </Box>
                  </TabPanel>
                </TabContext>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </Fragment>
  );
}

export default TrainerData;
